import { useState, useEffect } from "react"
import { Modal } from "react-bootstrap"
import closeButton from "../../assets/images/close.png"
import "../../assets/css/icon.css";
import "./Track-order.css";
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';


const SingleOrder = (props) => {
  const orderData = props?.order;
  const [showOrder, hideOrder] = useState(false);
  const deliveryStates = ["ASSIGNING_DRIVER", "ON_GOING", "PICKED_UP", "COMPLETED"]
  const [activeStateDelivery, changeStateDelivery] = useState(["", "", "", ""])
  const [showSummary, setShowSummary] = useState(false);

  const returnAddons = (obj) => {

    let addonString = ""
    if (obj.adons.length > 0) {
      for (let i = 0; i < obj.adons.length; ++i) {

        if (i === obj.adons.length - 1) {
          addonString += obj.adons[i].name
        } else {
          addonString += obj.adons[i].name + ", "
        }
      }
    }

    return addonString
  }

  useEffect(() => {
    if (props.order) {
      const status = props.order.lalamove_status
      let numOfActive = deliveryStates.indexOf(status)
      let x = [...activeStateDelivery]
      for (let i = 0; i <= numOfActive; ++i) {
        x[i] = "active" //make a shallow copy of the array
        console.log(activeStateDelivery)
        changeStateDelivery([...x])
      }
    }
  }, [props.order])

  return (
    <>
      <Modal size="sm" centered show={showOrder}>
        <Modal.Header>
          <h5 className="view-order">
            View Order
          </h5>
          <button style={{
            borderRadius: "50%",
            padding: "7px 7px 7px 15px",
            border: "1.2px solid black",
            backgroundColor: "white",
            height: "25px",
            width: "25px",
            position: "relative"
          }} className="m-1" onClick={() => { hideOrder(false) }}>
            <img style={{ position: "absolute", left: "4.7px", top: "4.85px", width: "14px", height: "14px" }} src={closeButton} />
          </button>
        </Modal.Header>

        <Modal.Body className="p-3">
          <div className="order-summary">
            <div
              style={{
                border: '1px solid #ccc',
                borderRadius: '8px',
                padding: '16px',
                width: '100%',  // lowercase "width"
                margin: '20px auto',
                backgroundColor: '#fff',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              }}
            >
              <table
                className="invoice-order-table"
                style={{
                  color: 'black',
                  width: '100%',
                  borderCollapse: 'collapse',
                  tableLayout: 'fixed', 
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #ccc', color: 'black' }}>
                    <th
                      style={{
                        textAlign: 'left',
                        padding: '8px',
                        borderRight: '1px solid #ccc',
                        borderBottom: '1px solid #ccc',
                        color: 'black',
                        fontWeight: 'bold',
                      }}
                    >
                      Invoice Number
                    </th>
                    <th
                      style={{
                        textAlign: 'right',
                        padding: '8px',
                        borderBottom: '1px solid #ccc',
                        color: 'black',
                        fontWeight: 'bold',
                      }}
                    >
                      Order Token Number
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr style={{ borderBottom: '1px solid #ccc' }}>
                    <td
                      style={{
                        textAlign: 'left',
                        padding: '8px',
                        borderRight: '1px solid #ccc',
                        fontSize: '14px',
                      }}
                    >
                      {orderData?.invoice_no}
                    </td>
                    <td
                      style={{
                        textAlign: 'right',
                        padding: '8px',
                        fontSize: '14px',
                      }}
                    >
                      {orderData?.order_token_no}
                    </td>
                  </tr>
                  <tr>
                    <td style={{
                      textAlign: 'left',
                      padding: '8px',
                      fontWeight: 'bold',

                    }}>
                      Order Number:
                    </td>
                    <td style={{
                      textAlign: 'right',
                      padding: '8px',
                      fontSize: '14px',
                    }}>
                      {orderData?.order_no}
                    </td>
                  </tr>
                  {/* Arrival Time Row */}
                  {orderData?.type_for_api !== "Pickup" && (
                    <tr style={{ borderTop: '1px solid #ccc' }}>
                      <td style={{
                        textAlign: 'left',
                        padding: '8px',
                        fontWeight: 'bold',
                      }}>
                        Arrival time:
                      </td>
                      <td style={{
                        textAlign: 'right',
                        padding: '8px',
                        fontSize: '14px',
                      }}>
                        {orderData?.estimated_arrival_time}
                      </td>
                    </tr>
                  )}

                </tbody>
              </table>
            </div>
            <div className="order-summary-dropdown">
              <button
                className="dropdown-toggle"
                onClick={() => setShowSummary(!showSummary)}
                style={{
                  width: '100%', // 🔹 Makes button full width
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  justifyContent: 'space-between', // 🔹 Push icon to far right
                  padding: '8px', // Optional padding
                  backgroundColor: '#fcfcfcff', // Optional background
                  border: 'none',
                  // Optional border
                  borderRadius: '6px',         // Optional rounding
                  boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 8px",
                  border: "1px solid rgb(204, 204, 204)",
                  cursor:"pointer"
                }}
              >
                Order Summary {showSummary ? <FaChevronUp /> : <FaChevronDown />}
              </button>

              {showSummary && (
                <div
                  style={{
                    maxHeight: '300px',     // limit height so it doesn't get too tall
                    overflowY: 'auto',           // same height as parent container
                    backgroundColor: 'white',
                    padding: '18px 30px',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                    zIndex: 1000,
                    marginTop: '4px',       // small gap below button
                  }}
                >

                  {/* Your existing dropdown and above table here */}

                  {/* Table with Item, Qty and Price below */}
                  <table className="items-table" style={{ width: '100%', color: 'black', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'left', borderBottom: '1px solid #ccc', padding: '8px' }}>Item</th>
                        <th style={{ textAlign: 'center', borderBottom: '1px solid #ccc', padding: '8px' }}>Qty</th>
                        <th style={{ textAlign: 'right', borderBottom: '1px solid #ccc', padding: '8px' }}>Price</th>

                      </tr>
                    </thead>
                    <tbody>
                      {
                        props.order && props.order.item.map((item, i) => (
                          <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                            <td style={{ padding: '8px', fontSize: '14px', }}>{item.name}
                              {item?.adons?.length > 0 && (
                                <div
                                  style={{
                                    marginTop: "4px",
                                    fontSize: "12px",
                                    color: "#666",
                                    boxShadow:"none"
                                  }}
                                >
                                  ({item.adons.map(e => `${e?.quantity || 1} ${e?.name || ""}`).filter(Boolean).join(", ")})
                                </div>
                              )}
                              {item?.combo_products?.length > 0 && (
                                <div
                                  style={{
                                    marginTop: "4px",
                                    fontSize: "12px",
                                    color: "#666",
                                    boxShadow:"none"
                                  }}
                                >
                                  ({item.combo_products.map(e => e?.name).filter(Boolean).join(", ")})
                                </div>
                              )}
                            </td>
                            <td style={{ textAlign: 'center', padding: '8px', fontSize: '14px', }}>{item.quantity}</td>
                            <td style={{ textAlign: 'right', padding: '8px', fontSize: '14px', }}>{item.total_for_single_item.toFixed(2)}</td>

                          </tr>
                        ))}
                      <>
                        {
                          orderData?.type_for_api === "Delivery" &&
                          <tr>
                            <td style={{ borderBottom: '1px solid #ccc' }}></td>
                            <td style={{ textAlign: 'center', padding: '8px', borderBottom: '1px solid #ccc', fontSize: '14px', }}>
                              Delivery Charge:
                            </td>
                            <td style={{ textAlign: 'right', padding: '8px', borderBottom: '1px solid #ccc', fontSize: '14px', }}>
                              {parseFloat(orderData?.delivery_charge).toFixed(2)}
                            </td>
                          </tr>
                        }
                        {orderData?.small_order_fee > 0 && (
                          <tr>
                            <td style={{ borderBottom: '1px solid #ccc' }}></td>
                            <td style={{ textAlign: 'center', padding: '8px', borderBottom: '1px solid #ccc', fontSize: '14px', }}>
                              Small Order Charge:
                            </td>
                            <td style={{ textAlign: 'right', padding: '8px', borderBottom: '1px solid #ccc', fontSize: '14px', }}>
                              {parseFloat(orderData?.small_order_fee).toFixed(2) ?? "0.00"}
                            </td>
                          </tr>)}
                      </>
                      <tr>
                        <td style={{ borderBottom: '1px solid #ccc' }}></td>
                        <td style={{ textAlign: 'center', padding: '5px', borderBottom: '1px solid #ccc', fontSize: '14px', }}>
                          Discount Amount:
                        </td>
                        <td style={{ textAlign: 'right', padding: '8px', borderBottom: '1px solid #ccc', fontSize: '14px', }}>
                          {orderData?.discount_amount}
                        </td>
                        <td style={{ borderBottom: '1px solid #ccc' }}></td>
                      </tr>
                      <tr>
                        <td style={{ borderBottom: '1px solid #ccc' }}></td>
                        <td style={{ textAlign: 'center', padding: '5px', borderBottom: '1px solid #ccc', fontSize: '14px', }}>
                          GST:
                        </td>
                        <td style={{ textAlign: 'right', padding: '8px', borderBottom: '1px solid #ccc', fontSize: '14px', }}>
                          {orderData?.tax_amount.toFixed(2)}
                        </td>
                        <td style={{ borderBottom: '1px solid #ccc' }}></td>
                      </tr>
                      <tr>
                        <td style={{ borderBottom: '2px solid #333' }}></td>
                        <td style={{ textAlign: 'center', padding: '5px', borderBottom: '2px solid #333', fontSize: '14px', }}>
                          Round off:
                        </td>
                        <td style={{ textAlign: 'right', padding: '8px', borderBottom: '2px solid #333', fontSize: '14px', }}>
                          {orderData?.round_off_amount && Number(orderData.round_off_amount.toFixed(2)) !== 0
                            ? `-${orderData.round_off_amount.toFixed(2)}`
                            : "0.00"}
                        </td>
                        <td style={{ borderBottom: '2px solid #333' }}></td>
                      </tr>

                      <tr style={{ borderBottom: '2px solid #333' }}>
                        <td style={{ padding: '8px' }}></td>
                        <td style={{ textAlign: 'center', padding: '8px', fontSize: '14px', }}>
                          Total + GST:
                        </td>
                        <td style={{ textAlign: 'right', padding: '8px', fontSize: '14px', }}>
                          {parseFloat(orderData?.received_amount).toFixed(2)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
          <Modal.Footer>
          <div className="view-order-btn" onClick={() => { hideOrder(false) }} >Close</div>
        </Modal.Footer>
        </Modal.Body>
      </Modal>

      <div className="main_section mb-5">
        <div className="track-gutter m-lg-5 m-md-5" data-testid={props.order.ref_no}>
          {(

            <div className="ins">
              {
                props?.order?.type_for_api === "Delivery" ? (<div className="panel-ember">
                  <div className="data">
                    <label className="control-label">Order Token Number</label>
                    <span className="form-control-static">
                      {" "}
                      {props?.order?.order_token_no}
                    </span>
                  </div>
                  <div>{["CANCELED", "EXPIRED"].includes(props?.order?.lalamove_status)? "Your order has been "+ props.order.lalamove_status: ""}</div>
                  <a onClick={() => { hideOrder(true) }}
                    // href={order.id && "/order-history/" + order.id} //CHANGE
                    className="btn primary"
                  >
                    View order
                  </a>
                </div>) :

                  (<div className="panel-ember">
                    <div className="data">
                      <label className="control-label">Order Token Number</label>
                      <span className="form-control-static">
                        {" "}
                        {props?.order?.order_token_no}
                      </span>
                    </div>
                    <a onClick={() => { hideOrder(true) }}
                      // href={order.id && "/order-history/" + order.id} //CHANGE
                      className="btn primary"
                    >
                      View order
                    </a>
                  </div>)
              }
              {props?.order?.type_for_api === "Delivery" ? (
                <>
                  <ul key={1} className="step-list">
                    <li data-status={0} className={activeStateDelivery[0]}>
                      <span>Assigning Driver</span>
                    </li>
                    <li data-status={1} className={activeStateDelivery[1]} >
                      <span>On Going</span>
                    </li>
                    <li data-status={2} className={activeStateDelivery[2]}>
                      <span>Picked Up</span>
                    </li>
                    <li data-status={3} className={activeStateDelivery[3]}
                    >
                      <span>Completed</span>
                    </li>
                  </ul>
                  <div key={2} className="box">
                    <div style={{ margin: 0 }} className="row">
                      <div className="col-md-6">
                        <div className="item-box">
                          <div className="form-group">
                            <label className="control-label">Deliver To</label>
                            <span className="form-control-static">
                              {props?.order?.d_address || "-"}
                            </span>
                          </div>
                          <div className="form-group">
                            <label className="control-label">
                              Estimated Arrival
                            </label>
                            <span className="form-control-static disabled">
                              <span className="date">
                                {props?.order?.estimated_arrival_time?.split(" ")[0]}
                              </span>
                              <span className="time mx-2">
                                {props?.order?.estimated_arrival_time?.split(" ")[1]}
                              </span>
                            </span>
                          </div>
                          <div className="form-group">
                            <label className="control-label">Payment</label>
                            <span className="form-control-static">
                              {props?.order?.paymentType?.toUpperCase()}  {props?.order?.last_4_card_digits}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="item-box">
                          <div className="form-group">
                            <label className="control-label">Contact us:</label>
                            <span className="form-control-static-call" style={{ fontWeight: "bold" }}>
                              {props?.order?.business_location_mobile_for_delivery}
                            </span>
                            {
                              props?.order?.lalamove_driver_info?.data &&
                              <div>
                                <label className="control-label">Contact driver:</label>
                                <span className="form-control-static-call" style={{ fontWeight: "bold" }}>
                                  {props?.order?.lalamove_driver_info?.data?.phone}
                                </span>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <ul key={1} className="step-list">
                    <li
                      className={"active"
                      }
                    >
                      <span>Order Received</span>
                    </li>
                    <li className={props.order.pickup_completed !== 0 ? "active" : ""}
                    >
                      <span>Collected</span>
                    </li>
                  </ul>
                  <div key={2} className="box">
                    <div style={{ margin: 0 }} className="row">
                      <div className="col-md-6">
                        <div className="item-box">
                          <div className="form-group">
                            <label className="control-label">Pick up outlet</label>
                            <span className="form-control-static">
                              {props.order.business_location_name_for_pickup ? props.order.business_location_name_for_pickup : "NA"}
                            </span>
                          </div>
                          <div className="form-group">
                            <label className="control-label">
                              Picked up time
                            </label>
                            <span className="form-control-static disabled">
                              <span style={{ color: "#4B4B4B" }}>
                                {props.order.d_date}
                              </span>
                              <span style={{ color: "#4B4B4B" }}>
                                {props.order.d_time}
                              </span>
                            </span>
                          </div>
                          <div className="form-group">
                            <label className="control-label">Payment</label>
                            {props.order.paymentType === "cash" || props.order.paymentType === "paynow" ? (
                              <span className="form-control-static">
                                {props.order.paymentType.toUpperCase()}
                              </span>
                            ) : (
                              <span className="form-control-static">
                                {props.order.card_type
                                  ? (props.order.card_type.toLowerCase() === "rapyd"
                                    ? "CARD"
                                    : props.order.card_type.toUpperCase())
                                  : ""}{" "}{props.order.card_type === "paynow" ? "" : props.order.last_4_card_digits}
                              </span>
                            )}

                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="item-box">
                          <div className="form-group">
                            <label className="control-label">Contact us:</label>
                            <span className="form-control-static-call" style={{ fontWeight: "bold" }}>
                              {props.order.business_location_mobile_for_pickup ? props.order.business_location_mobile_for_pickup : "NA"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default SingleOrder;